// extracted by mini-css-extract-plugin
module.exports = {"homeScale_content":"homeScale_homeScale_content__2ihpm","content_wrap":"homeScale_content_wrap__2_usI"};